<template>
  <div class="landing-large-card">
    <div class="landing-large-card__body">
      <div class="landing-large-card__title">{{ title }}</div>
      <div class="landing-large-card__description">{{ description }}</div>
    </div>
    <div class="landing-large-card__image">
      <img
        loading="lazy"
        alt=""
        :src="imageSrc"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'LandingLargeCard',
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    imageSrc: {
      type: String,
      required: true,
    },
  },
};
</script>

<style
  scoped
  lang="scss"
>
@import "~@/assets/scss/mixins";


.landing-large-card {
  display: flex;
  flex-direction: column;
  color: var(--light);
  gap: 10px;

  @include media-lg() {
    gap: 24px;
    padding: 48px;
    border-radius: 24px;
    color: #570c59;
    background-color: var(--light);
  }

  &__title {
    margin-bottom: 24px;

    font-size: 24px;
    line-height: 32px;
    font-weight: 700;
    text-align: center;

    @include media-lg() {
      font-size: 32px;
      line-height: 40px;
      text-align: initial;
    }
  }

  &__description {
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    text-align: center;

    @include media-lg() {
      font-size: 18px;
      text-align: initial;
    }
  }

  &__image {

    @include media-sm-only() {
      display: flex;
      justify-content: center;
      width: 100%;
      height: 224px;
    }

    @include media-lg() {
      height: 257px;
      width: 452px;
    }

    img {
      height: 100%;
      object-fit: contain;


      @include media-sm-only() {
        width: 327px;
      }
    }
  }
}

</style>
